import { useEffect, useState } from "react";
import UserContext from "./UserContext";
import authService from "../services/authService";

export const UserState = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginError, setLoginError] = useState(false);

  /* =========================
     Restaurar sesión guardada
  ========================= */
  useEffect(() => {
    authService.getMe()
      .then((res) => setUser(res.data))
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  /* =========================
     Login
  ========================= */
  const Login = async (user, password) => {
    setLoginError(false);
    try {
      const { data } = await authService.login({ user: user.trim(), password });
      setUser(data);
    } catch (error) {
      setLoginError(true);
    }
  };

  /* =========================
     Logout
  ========================= */
  const Logout = async () => {
    await authService.logout();
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        setLoading,
        loginError,
        Login,
        Logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
